import { API } from 'aws-amplify';

export const SystemActionsService = {
    getSystemAction: async (id) => {
        const data = await API.get(
            'datacorAPIWithCustAuth',
            `/workflow/systemActions/${id}`
        );
        return data;
    },
    getSystemActionFull: async (id) => {
        const data = await API.get(
            'datacorAPIWithCustAuth',
            `/workflow/systemActions/${id}?full=true`
        );
        return data;
    },
    runSystemAction: async (id) => {
        const data = await API.get(
            'datacorAPIWithCustAuth',
            `/workflow/systemActions/${id}/run`
        );
        return data;
    },
};
